(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["headerv2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Listen for the custom event to open the minicart
    document.addEventListener('cart-items-section:rendered', () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        const cartDrawer = /** @type {any} */ (document.getElementById('header-drawer-cart'));
        if (cartDrawer && typeof cartDrawer.showModal === 'function') {
          cartDrawer.showModal();
        }
      }
    });

    document.addEventListener('wishlist:update', (event) => {
      const { wishlist } = event.detail;

      showAddedToWishlistModal(wishlist.productHandle, wishlist.variantId);
    });
  });

  // Function to refresh only the cart dropdown using Shopify's section rendering API
  function refreshHeaderSection() {
    const cartDropdown = document.querySelector('#cart-dropdown');
    const cartCounter = document.querySelectorAll('.header__cart-counter');
    if (!cartDropdown) return;

    fetch(`${window.location.pathname}?section_id=headerv2`)
      .then((response) => response.text())
      .then((html) => {
        // Create a temporary container to parse the response
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Find the cart dropdown in the response
        const newCartDropdown = tempDiv.querySelector('#cart-dropdown');
        if (newCartDropdown) {
          // Replace the current cart dropdown with the updated one
          cartDropdown.replaceWith(newCartDropdown);
        }

        // Update cart counters (mobile and desktop)
        const newCartCounters = tempDiv.querySelectorAll('.header__cart-counter');
        cartCounter.forEach((counter, index) => {
          if (newCartCounters[index]) {
            counter.replaceWith(newCartCounters[index]);
          } else {
            // Remove counter if cart is empty
            counter.remove();
          }
        });
      })
      .catch((error) => {
        console.error('Error refreshing cart dropdown:', error);
        // Fallback to page reload if section rendering fails
        window.location.reload();
      });
  }

  // Function to show the added to wishlist modal
  function showAddedToWishlistModal(productIdentifier = null, variantId = null) {
    // const modal = document.querySelector('#added-to-wishlist-modal');
    // if (!modal) return;

    console.log('Show added to wishlist modal', productIdentifier);

    // Load product content via Shopify section rendering if product identifier is provided
    if (!productIdentifier || !variantId) return;

    // loadCartNotificationProduct(productIdentifier, variantId, 'wishlist');
  }

  // Function to get fallback product handle from various sources
  function getFallbackProductHandle(productId, cartData) {
    // Try to get from cart data first
    if (cartData && cartData.items && cartData.items.length > 0) {
      const latestItem = cartData.items[cartData.items.length - 1];
      if (latestItem && latestItem.product_handle) {
        return latestItem.product_handle;
      }
    }

    // Try to get from current page URL
    const currentProductHandle = getCurrentProductHandle();
    if (currentProductHandle) {
      return currentProductHandle;
    }

    // If all else fails, return null to show basic notification
    return null;
  }

  // Function to get current product handle from URL
  function getCurrentProductHandle() {
    const path = window.location.pathname;
    const productMatch = path.match(/\/products\/([^\/\?]+)/);
    if (productMatch) {
      return productMatch[1];
    }
    return null;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const newsletterInput = document.getElementById('NewsletterInput');
    const newsletterActions = document.getElementById('NewsletterActions');

    if (newsletterInput && newsletterActions) {
      newsletterInput.addEventListener(
        'focus',
        function () {
          newsletterActions.classList.add('is-focused');
          newsletterActions.classList.remove('hidden');
        },
        { once: true }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-template"]) return;
  try {
    
  //Search Clear Button
  document.getElementById('searchClearButton').addEventListener('click', () => {
    const searchInput = document.querySelector('#SearchForm input[type="search"]');
    searchInput.value = '';
    searchInput.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
